import React from 'react';
import { motion } from 'framer-motion';
import { FloatingSparkles } from './FloatingSparkles';
export function FinalCTA() {
  return <section className="py-24 bg-burgundy text-center px-6 relative overflow-hidden" data-id="element-136">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-137"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-rosegold/30 rounded-full blur-[120px] pointer-events-none animate-pulse" data-id="element-138"></div>

      <FloatingSparkles count={50} color="#FFFFFF" className="opacity-70" data-id="element-139" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto relative z-10" data-id="element-140">
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-8 leading-tight" data-id="element-141">
          Tu vida extraordinaria está a una decisión de distancia.
        </h2>
        <p className="text-xl text-cream/80 mb-12 italic" data-id="element-142">
          ¿Estás lista para volver a ti?
        </p>
        <a href="https://pay.hotmart.com/B104808844T" target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-block bg-white text-burgundy px-10 py-4 rounded-full text-lg font-medium hover:bg-cream transition-all shadow-[0_0_30px_rgba(255,255,255,0.3)] transform hover:-translate-y-0.5" data-id="element-143">
          Sí, quiero empezar mi transformación
        </a>
      </motion.div>
    </section>;
}